import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  DateField,
  FunctionField,
} from "react-admin";

import { ListNoResultsWithFilters } from "@/components/ListNoResultsWithFilters";
import { ListPaginationByLimit } from "@/components/pagination";
import { FILTER_LIMITS } from "@/constants/filters";
import { useClientApps } from "@/modules/clientApps";

import { ClientAppField } from "./ClientAppField";
import { TICKET_TYPES } from "./constants";
import { ticketsListFilters } from "./TicketsListFilters";

const maxWidthStyle = {
  display: "block",
  maxWidth: "15vw",
  overflowX: "auto",
};

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
  </TopToolbar>
);

const DEFAULT_FILTERS = {
  limit: FILTER_LIMITS[0],
};

export const TicketsList = () => {
  const { data: { clientAppsObject } = {} } = useClientApps();

  return (
    <List
      filters={ticketsListFilters}
      filterDefaultValues={DEFAULT_FILTERS}
      pagination={<ListPaginationByLimit />}
      actions={<ListActions />}
      sort={{ field: "id", order: "DESC" }}
      storeKey={false}
    >
      <DatagridConfigurable
        style={{ tableLayout: "auto" }}
        bulkActionButtons={false}
        omit={["updateAt"]}
        empty={<ListNoResultsWithFilters defaultFilters={DEFAULT_FILTERS} />}
      >
        <TextField source="id" sx={maxWidthStyle} />
        <TextField source="deviceId" label="Device Id" />
        <TextField source="email" sx={maxWidthStyle} />
        <TextField source="issue" sx={maxWidthStyle} />
        <TextField source="systemInfo" />
        <DateField source="createAt" sortable={false} />
        <DateField source="updateAt" sortable={false} />
        <FunctionField
          source="clientAppId"
          sortable={false}
          render={(record: { clientAppId?: string | null }) => {
            const { clientAppId = null } = record;
            return clientAppsObject && clientAppId ? (
              <ClientAppField clientApp={clientAppsObject[clientAppId]} />
            ) : (
              clientAppId
            );
          }}
        />
        <FunctionField
          source="type"
          sortable={false}
          render={(record: { type?: keyof typeof TICKET_TYPES }) =>
            record.type ? TICKET_TYPES[record.type] : ""
          }
        />
      </DatagridConfigurable>
    </List>
  );
};
